import { useEffect, useState } from 'react';

let cachedKey: string | undefined;
let loadPromise: Promise<string> | undefined;

/** Runtime config — key is not read from import.meta.env (avoids build-time inlining). */
export function loadGoogleMapsApiKey(): Promise<string> {
  if (cachedKey !== undefined) return Promise.resolve(cachedKey);
  if (!loadPromise) {
    loadPromise = fetch('/runtime-config.json', { credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : {}))
      .then((data) => String((data as any)?.googleMapsApiKey ?? '').trim())
      .catch(() => '')
      .then((key) => {
        cachedKey = key;
        return key;
      });
  }
  return loadPromise;
}

export function useGoogleMapsApiKey() {
  const [apiKey, setApiKey] = useState(cachedKey ?? '');
  const [loading, setLoading] = useState(cachedKey === undefined);

  useEffect(() => {
    let cancelled = false;
    loadGoogleMapsApiKey().then((key) => {
      if (cancelled) return;
      setApiKey(key);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { apiKey, loading, hasApiKey: Boolean(apiKey) };
}
